// removed by extract-text-webpack-plugin
module.exports = {"bubble-container":"bubble__bubble-container___3Ikr8","bubble":"bubble__bubble___2ajAp","bubble--full":"bubble__bubble--full___R246Y","bubble--me":"bubble__bubble--me___GrFh_","bubble--hidden":"bubble__bubble--hidden___2Ta_-"};


//////////////////
// WEBPACK FOOTER
// ./src/js/Components/Bubble/bubble.scss
// module id = 115
// module chunks = 0